"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import LegalStamp from "./legal-stamp";

export default function Footer() {
  const pathname = usePathname();

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    if (!contactSection) return;
    contactSection.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      className="bg-[#0d0a07] border-t border-[#e8620a]/[0.10] py-8 px-[18px] sm:px-10 lg:px-16"
      aria-label="Pied de page"
    >
      <div className="max-w-5xl mx-auto">
        {/* Top row: brand + legal block */}
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-6 pb-6 border-b border-white/[0.06]">
          <div className="flex flex-col sm:flex-row items-start gap-4 sm:gap-5">
            <LegalStamp size={56} />
            <div className="flex flex-col gap-1.5">
              <div className="flex items-center gap-2">
                <svg width="8" height="8" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                  <path
                    d="M6 0.5L7.4 4.4H11.5L8.2 6.8L9.5 10.7L6 8.3L2.5 10.7L3.8 6.8L0.5 4.4H4.6L6 0.5Z"
                    fill="rgba(232,98,10,0.35)"
                    strokeWidth="0.8"
                  />
                </svg>
                <span
                  className="text-white/45 uppercase tracking-[0.16em]"
                  style={{ fontFamily: "var(--cp-font-barlow-condensed)", fontSize: 10 }}
                >
                  © 2025 Cartel Paradise — Fabriqué en France
                </span>
              </div>
              <span
                className="text-white/20 uppercase tracking-[0.10em]"
                style={{ fontFamily: "var(--cp-font-geist-mono), monospace", fontSize: 8 }}
              >
                1 rue du Château de Bel Air · Carquefou
              </span>
            </div>
          </div>

          <nav aria-label="Liens de contact et légaux" className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <Link
              href="/distributeurs"
              onClick={(event) => {
                if (pathname !== "/") return;
                event.preventDefault();
                scrollToContact();
              }}
              className="text-white/50 uppercase tracking-[0.2em] hover:text-white/80 transition-colors"
              style={{ fontFamily: "var(--cp-font-barlow-condensed)", fontSize: 10 }}
            >
              Devenir distributeur
            </Link>
            <a
              href="mailto:contact@cartelparadise.com"
              className="text-white/50 uppercase tracking-[0.2em] hover:text-white/80 transition-colors"
              style={{ fontFamily: "var(--cp-font-barlow-condensed)", fontSize: 10 }}
            >
              Contact
            </a>
            <Link
              href="/mentions-legales"
              className="text-white/30 uppercase tracking-[0.2em] hover:text-white/60 transition-colors"
              style={{ fontFamily: "var(--cp-font-barlow-condensed)", fontSize: 10 }}
            >
              Mentions légales
            </Link>
          </nav>
        </div>

        {/* Bottom row: Loi Évin banner */}
        <div className="pt-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="flex items-center gap-2">
            <span
              className="inline-flex items-center justify-center px-2 py-0.5 text-[9px] font-bold uppercase tracking-[0.12em] text-[#0d0a07]"
              style={{ fontFamily: "var(--cp-font-barlow-condensed)", background: "#e8620a" }}
            >
              18+
            </span>
            <p
              className="text-white/35 uppercase tracking-[0.12em]"
              style={{ fontFamily: "var(--cp-font-barlow-condensed)", fontSize: 10 }}
            >
              L&apos;abus d&apos;alcool est dangereux pour la santé — À consommer avec modération
            </p>
          </div>
          <p
            className="text-white/20 uppercase tracking-[0.10em]"
            style={{ fontFamily: "var(--cp-font-geist-mono), monospace", fontSize: 8 }}
          >
            Vente d&apos;alcool interdite aux mineurs — Loi Évin
          </p>
        </div>
      </div>
    </footer>
  );
}
